module.exports = __webpack_public_path__ + "img/body-model-clothes.e7d7f0d7.svg";